/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { notification } from 'antd';
import { v1 as uuidv1 } from 'uuid';
import { api } from '@seaoil/component-lib';

import AsyncAutoComplete from './AsyncAutoComplete';

const { mySEAOIL } = api;

function ExpenseSubCategory2Field({
  // attributes
  placeholder,
  disabled,

  // object attributes
  config: {
    company_code,
    category,
    subcategory_1,
  },

  // methods
  onInputSelect,
}) {
  const [subCategories, setSubCategories] = useState([]);
  const [loading, isLoading] = useState(false);
  const [key, setKey] = useState(uuidv1());
  const [options, setOptions] = useState([]);
  const retryLimit = 5;
  let retryCount = 0;

  const loadSubCategories = async () => {
    isLoading(true);
    try {
      const subCats = await mySEAOIL.datawarehouse.getExpenseAcctEntry({
        attribute: 'subcategory_2',
        parameters: { company_code, category, subcategory_1 },
      }).send();
      setSubCategories(subCats);
    } catch (e) {
      if (retryCount > retryLimit) {
        notification.error({ message: 'Unable to load subcategory 2 after multiple retries. Kindly contact supportdesk@seaoil.com.ph' });
      } else {
        notification.error({ message: 'Unable to load subcategory 2. Retrying after 2 seconds...' });
        setTimeout(loadSubCategories, 2000);
        retryCount += 1;
      }
    } finally {
      isLoading(false);
    }
  };

  useEffect(() => {
    setKey(uuidv1());
    setOptions([]);
    if (company_code && category && subcategory_1) {
      loadSubCategories();
    }
  }, [company_code, category, subcategory_1]);

  useEffect(() => {
    if (!Array.isArray(subCategories)) {
      return;
    }

    setOptions(subCategories.map(({
      subcategory_2,
    }) => ({
      value: subcategory_2,
      label: subcategory_2,
    })));
  }, [subCategories]);

  return (
    <AsyncAutoComplete
      key={key}
      placeholder={placeholder}
      loading={loading}
      disabled={disabled}
      options={options}
      onInputSelect={(subcat2) => {
        if (subCategories) {
          onInputSelect(subCategories.find(({ subcategory_2 }) => subcategory_2 === subcat2));
        }
      }}
    />
  );
}

export default ExpenseSubCategory2Field;
